import React, { useState } from "react";
import { connect } from "react-redux";

// Custom Styled
import {
  Box,
  Container,
  GamePad,
  MatchBoxStrip,
  LottieAnimation,
  LeftRightArrow,
  DiceButton,
} from "./TutorialStyle";

// Images
import thinking from "../../assets/lottieAnimation/Thinking.json";
import grain from "./../../assets/images/grain.svg";
//Custom
import { IButtonLinkArea, KaudiImage, RoomImage } from "../Game/GameStyle";
import Button from "../../component/Button/Button";
import Message from "../../component/Message/Message";
import stringValues from "../../stringValues";
import { images } from "../../imageValues";
import { playSound, AxlTracker } from "../../utils";
import { useAxL } from "../../AxLContext";
import { TutorialContentArea } from "../../component/Message/messageStyle";

const numberOfBox = 64;

const Tutorial = ({ onClick, playPauseSoundState, changeLanguageState }) => {
  const [showTutorialScreen, setShowTutorialScreen] = useState(1);
  const [showInfo, setShowInfo] = useState(false);
  const axl = useAxL();

  const checkPage = () => {
    if (showTutorialScreen === 5) {
      onClick();
    }
    playSound(playPauseSoundState);
    setShowTutorialScreen(showTutorialScreen + 1);
    AxlTracker(axl, "Clicked on Next", "Next Tutorial Screens", 13, true);
  };

  const previousPage = () => {
    playSound(playPauseSoundState);
    setShowTutorialScreen(showTutorialScreen - 1);
    AxlTracker(
      axl,
      "Clicked on Previous",
      "Previous Tutorial Screens",
      14,
      true
    );
  };

  const renderTutorial = () => {
    return (
      <div
        style={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          height: "100%",
        }}
      >
        {showTutorialScreen === 1 ? (
          <div>
            <TutorialContentArea style={{ left: 83, top: 40 }}>
              {stringValues[changeLanguageState.data].first}
              <br /> {stringValues[changeLanguageState.data].yourGoal}
            </TutorialContentArea>
            <LottieAnimation
              animationData={thinking}
              style={{
                marginLeft: -10,
              }}
            />
          </div>
        ) : showTutorialScreen === 2 ? (
          <div
            style={{
              justifyContent: "flex-end",
              alignItems: "center",
              display: "flex",
              height: "100%",
              flexDirection: "column",
            }}
          >
            <div style={{ flex: 0.4 }}>
              <Message
                label={stringValues[changeLanguageState.data].tutorialLabel2}
                style={{ left: 84, top: 20 }}
              />
              <LottieAnimation
                animationData={thinking}
                style={{ marginLeft: 30 }}
              />
              <div
                style={{
                  height: 76,
                  width: 84,
                  backgroundColor: "orange",
                  backgroundImage: `url(${grain})`,
                  backgroundBlendMode: "multiply",
                  marginLeft: 10,
                  marginBottom: 10,
                }}
              >
                <KaudiImage
                  src={images.ROLLSIX}
                  style={{
                    height: 76,
                    width: 84,
                  }}
                />
              </div>
            </div>
          </div>
        ) : showTutorialScreen === 3 ? (
          <div
            style={{
              display: "flex",
              justifyContent: "flex-end",
              alignItems: "center",
              height: "100%",
              flexDirection: "column",
              marginBottom: 300,
              marginRight: 20,
            }}
          >
            <Message
              label={stringValues[changeLanguageState.data].tutorialLabel3}
              style={{ top: 15, left: 47 }}
            />
            <div
              style={{
                flexDirection: "row",
                display: "flex",
                alignItems: "center",
                height: "25%",
              }}
            >
              <LottieAnimation
                animationData={thinking}
                style={{
                  marginRight: 25,
                  marginBottom: 90,
                }}
              />
              <img
                src={images.MARKETONENEW}
                style={{
                  height: 90,
                  width: 150,
                  marginRight: 35,
                }}
                alt="BazaarOneImage"
              />
            </div>
          </div>
        ) : showTutorialScreen === 4 ? (
          <div
            style={{
              alignItems: "center",
              display: "flex",
              height: "100%",
              width: "100%",
              flexDirection: "column",
              justifyContent: "flex-end",
              paddingBottom: 300,
            }}
          >
            <div style={{ display: "flex" }}>
              <img
                src={images.OLDCAR}
                style={{
                  height: 150,
                  width: 150,
                  marginTop: -25,
                }}
                alt="OldCarImage"
              />
              <div
                style={{
                  display: "flex",
                  flexDirection: "column",
                }}
              >
                <Message
                  label={stringValues[changeLanguageState.data].tutorialLabel4}
                  style={{
                    marginLeft: -26,
                  }}
                />
                <LottieAnimation
                  style={{
                    marginLeft: -50,
                    marginTop: -40,
                  }}
                  animationData={thinking}
                />
              </div>
            </div>
          </div>
        ) : showTutorialScreen === 5 ? (
          <div
            style={{
              display: "flex",
              flexDirection: "column",
              height: "100%",
            }}
          >
            <div
              style={{
                display: "flex",
                flexDirection: "column",
              }}
            >
              <RoomImage
                src={
                  changeLanguageState.data === "en"
                    ? images.COLLECTORROOMNEW
                    : images.ROOMHINDI
                }
                style={{ marginTop: 5, bottom: 20 }}
              />
              <div
                style={{
                  zIndex: 1,
                }}
              >
                <Message
                  label={stringValues[changeLanguageState.data].tutorialLabel5}
                  style={{ left: 80 }}
                />
              </div>
              <LottieAnimation
                animationData={thinking}
                style={{
                  marginTop: -80,
                  marginLeft: -40,
                  zIndex: 2,
                }}
              />
            </div>
          </div>
        ) : (
          <></>
        )}
        <div
          style={{
            position: "absolute",
            bottom: 30,
            right: 10,
            width: 130,
            justifyContent: "center",
            alignItems: "center",
            display: "flex",
            flexDirection: "column",
          }}
        >
          <div
            style={{
              justifyContent: "space-between",
              alignItems: "center",
              display: "flex",
              width: "100%",
              marginBottom: 10,
            }}
          >
            {showTutorialScreen !== 1 ? (
              <LeftRightArrow onClick={previousPage} style={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
              }}>
                <img
                  src={images.BACKARROWTWO}
                  alt="LeftArrowImage"
                  style={{ width: 10 }}
                />
              </LeftRightArrow>
            ) : (
              <div></div>
            )}
            <LeftRightArrow
              onClick={() => {
                checkPage();
              }}
            >
              <img
                src={images.BACKARROWTWO}
                style={{
                  transform: "rotate(180deg)",
                  marginTop: 6,
                  width: 10,
                }}
                alt="LeftArrowInvertedImage"
              />
            </LeftRightArrow>
          </div>
          <Button
            label={stringValues[changeLanguageState.data].skipButton}
            onClick={() => {
              onClick();
              playSound(playPauseSoundState);
              AxlTracker(
                axl,
                "Clicked on Skip",
                "Skipped Tutorial Screens",
                15,
                true
              );
            }}
          />
        </div>
      </div>
    );
  };

  return (
    <Container>
      <div
        style={{
          position: "relative",
          height: "100%",
          width: "100%",
          display: "flex",
          alignItems: "center",
          flexDirection: "column",
          justifyContent: "center",
        }}
      >
        <div
          style={{
            position: "absolute",
            height: "100%",
            width: "100%",
            backgroundColor: "rgba(0,0,0,0.74)",
          }}
        >
          {renderTutorial()}
        </div>

        <div style={{ height: 200 }}>
          {showTutorialScreen === 5 ? (
            <></>
          ) : (
            <RoomImage
              src={
                changeLanguageState.data === "en"
                  ? images.COLLECTORROOMNEW
                  : images.ROOMHINDI
              }
            />
          )}
        </div>
        {/* <IButtonLinkArea> */}
        <MatchBoxStrip src={images.MATCHBOXSTRIP} />
        {/* </IButtonLinkArea> */}
        <GamePad>
          {[...Array(numberOfBox)].map((e, key) => {
            return <Box key={key} className="box"></Box>;
          })}
        </GamePad>
        <MatchBoxStrip src={images.MATCHBOXSTRIP} />
        <div style={{ width: 380, display: "flex" }}>
          <DiceButton>
            {showTutorialScreen !== 2 ? (
              <KaudiImage
                src={images.ROLLFIVE}
                style={{
                  height: 72,
                  width: 75,
                  left: 0,
                }}
              />
            ) : (
              <div style={{ height: 74, width: 72 }}></div>
            )}
          </DiceButton>
        </div>
      </div>
    </Container>
  );
};

const mapStateToProps = (state) => ({
  playPauseSoundState: state.playPauseSound,
  changeLanguageState: state.changeLanguage,
});
export default connect(mapStateToProps, null)(Tutorial);
